import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { create, getDetail as _getDetail, update } from '@/api/setting/third-party';
export default {
  name: 'form-dialog',
  props: {
    types: {
      default: function _default() {
        return [];
      }
    },
    id: {
      type: String,
      default: function _default() {
        return undefined;
      }
    }
  },
  data: function data() {
    return {
      form: {
        n03Name: undefined,
        n03Type: undefined,
        n03Supplier: undefined,
        n03Sdate: undefined,
        n03Edate: undefined,
        n03Parameter1: undefined,
        n03Parameter2: undefined,
        n03Parameter3: undefined,
        n03Parameter4: undefined,
        n03Account: undefined,
        n03Password: undefined
      },
      rules: {
        n03Name: [{
          required: true,
          message: '请输入名称',
          trigger: 'change'
        }],
        n03Type: [{
          required: true,
          message: '请选择类型',
          trigger: 'change'
        }],
        n03Supplier: [{
          required: true,
          message: '请输入供应商',
          trigger: 'change'
        }],
        n03Sdate: [{
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }],
        n03Account: [{
          required: true,
          message: '请输入账号',
          trigger: 'change'
        }],
        n03Password: [{
          required: true,
          message: '请输入密码',
          trigger: 'change'
        }]
      },
      loading: false
    };
  },
  methods: {
    cancel: function cancel() {
      this.$emit('cancel');
    },
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$checkForm();
            case 1:
              _this.loading = true;
              _context.n = 2;
              return _this.$awaitTo(_this.id ? update(_this.id, _this.form) : create(_this.form));
            case 2:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 1);
              err = _yield$_this$$awaitTo2[0];
              _this.loading = false;
              if (!err) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              _this.$emit('submit');
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getDetail: function getDetail() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.loading = true;
              _context2.n = 1;
              return _this2.$awaitTo(_getDetail(_this2.id));
            case 1:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              data = _yield$_this2$$awaitT2[1];
              _this2.loading = false;
              if (!err) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              _this2.form = data;
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    if (this.id) {
      this.getDetail();
    }
  }
};